<template>
  <component
    :is="hasSubItems ? BaseButton : getActionLinkComponent(content.target)"
    :aria-haspopup="hasSubItems ? 'true' : undefined"
    class="w-full flex items-center px-5 py-4 between"
    :class="{ 'cursor-pointer bg-transparent text-left': !hasSubItems && isActionLinkOnly(content.target) }"
    v-bind="hasSubItems ? {} : getActionLinkAttrs(content.target)"
    @click="handleClick"
  >
    <span :class="[brandClasses.title, presets?.[content.menuStyle!]]">
      <span v-if="$feature.showTitleHtml" v-html="content.titleHtml" />
      <template v-else>
        {{ content.title }}
      </template>
    </span>
    <vf-icon v-if="hasSubItems" dir="right" name="chevron" size="md" />
  </component>
</template>

<script lang="ts" setup>
import type { MegaMenuL1Context } from '#content/contexts/megamenu'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { BaseButton } from '#components'
import { MegaMenuL1ContextKey } from '#content/contexts/megamenu'

const { content } = defineProps<{ content: MenuItem }>()

const emit = defineEmits<{
  click: []
  expand: []
}>()

const { getActionLinkAttrs, getActionLinkComponent, isActionLinkOnly } = useCmsActionLink()
const { brandClasses, presets } = useAppConfig().components.cms.megaMenuL1Mobile

const { activeL1 } = inject(MegaMenuL1ContextKey, {} as MegaMenuL1Context)

const hasSubItems = computed(() =>
  content.columns?.some(({ children }) => children?.some(({ hideOnWeb }) => !hideOnWeb)) || content.visualSelectors
)

const handleClick = () => {
  if (hasSubItems.value) {
    if (activeL1) activeL1.value = content
    emit('expand')
  }
  else {
    emit('click')
  }
}
</script>
